import { createFromIconfontCN } from '@ant-design/icons';
import Settings from '../../config/defaultSettings';

export const IconFont = createFromIconfontCN({
  scriptUrl: Settings.iconfontUrl,
});
